export default "__VITE_ASSET__DZhHIU_e__"